<template>
  <div class="q-toolbar">
    <!--    <div class="toolbar-title">-->
    <!--      <span>{{ toolbarTitle }}</span>-->
    <!--    </div>-->

    <div class="q-toolbar-buttons">
      <q-button-group
        v-for="group in model"
        :key="group.key"
      >
        <q-button
          v-for="button in group.buttons"
          :key="button.key"
          size="mini"
          class="toolbar-button"
          :type="button.type"
          :plain="button.plain"
          @click="click(button.key)"
        >
          <span>{{ button.caption }}</span>
          <font-awesome-icon
            v-if="button.icon"
            :icon="['fas', button.icon]"
          />
        </q-button>
      </q-button-group>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'QToolbar',

    props: {
      groups: {type: Array},
      toolbarTitle: {type: String, default: '-'}
    },

    data() {
      return {
        model: [
          {
            key: '1',
            buttons: [
              {
                key: 'gooz',
                type: null,
                icon: 'trash',
                caption: null,
                plain: true
              },
              {
                key: 'gooz1',
                type: null,
                icon: 'edit',
                caption: null,
                plain: true
              },
              {
                key: 'gooz2',
                type: null,
                icon: null,
                caption: 'next',
                plain: true
              }
            ]
          },
          {
            key: '2',
            buttons: [
              {
                key: 'last',
                type: null,
                icon: null,
                caption: 'Last',
                plain: true
              },
              {
                key: 'first',
                type: null,
                icon: null,
                caption: 'First',
                plain: true
              }
            ]
          }
        ],
      }
    },

    methods: {
      click(key) {
        this.$emit('buttonClick', key);
      }
    }
  };
</script>

<style scoped>
  .q-toolbar {
    margin-bottom: 5px;
  }

  .q-toolbar-buttons {
    display: -webkit-box;
    display: -ms-flexbox;

    display: flex;
    line-height: 34px;
  }

  .toolbar-button {
    line-height: 16px;
  }

  .toolbar-title {
    background-color: #8e8e8e;
    color: #303133;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 5px;
  }
</style>